import { render, staticRenderFns } from "./StandardChart.vue?vue&type=template&id=153d9c34&lang=pug"
import script from "./StandardChart.vue?vue&type=script&lang=js"
export * from "./StandardChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports